<template>
  <w-icon-wrapper icon-name='work-back-icon'>
    <g
      id='_46_Zurück_Icon'
      data-name='46 Zurück_Icon'
      transform='translate(0.187 -0.06)'
    >
      <g
        id='Gruppe_25438'
        data-name='Gruppe 25438'
      >
        <path
          id='Pfad_55737'
          d='M11.813,24.06a12,12,0,1,0-12-12A12,12,0,0,0,11.813,24.06Zm0-22a10,10,0,1,1-10,10A10.011,10.011,0,0,1,11.813,2.06Z'
          data-name='Pfad 55737'
          fill='currentColor'
        />
      </g>
      <path
        id='Pfad_55738'
        d='M4.794,12.72a.945.945,0,0,0,.077.078l2.943,2.966a1,1,0,1,0,1.42-1.408l-1.285-1.3H18.524a1,1,0,0,0,0-2H7.964l1.32-1.283a1,1,0,0,0-1.4-1.434L4.1,12.023Z'
        data-name='Pfad 55738'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconBack' };
</script>
